(() => {
  const grid = document.querySelector('.nh-collection-grid');
  const button = document.querySelector('[data-nh-load-more]');
  if (!grid || !button || button.dataset.autoloadReady) return;
  button.dataset.autoloadReady = 'true';

  const container = button.closest('.nh-collection-more');
  const status = document.createElement('span');
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  Object.assign(status.style, {
    position: 'absolute', width: '1px', height: '1px',
    overflow: 'hidden', clipPath: 'inset(50%)', whiteSpace: 'nowrap',
  });
  grid.after(status);

  let loading = false;
  let finished = false;
  let automatic = true;
  let observer;
  const loadedPages = new Set();
  const productKey = (card) => {
    const link = card.querySelector('a[href*="/products/"]');
    return link ? new URL(link.getAttribute('href'), location.href).pathname : null;
  };
  const products = new Set(Array.from(grid.children, productKey).filter(Boolean));

  async function loadMore(manual = false) {
    if (loading || finished || (!manual && !automatic)) return;
    const url = new URL(button.href, location.href);
    if (url.origin !== location.origin || loadedPages.has(url.href)) return;
    loading = true;
    observer?.unobserve(container);
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    grid.setAttribute('aria-busy', 'true');
    button.textContent = 'Chargement\u2026';
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 20000);

    try {
      const response = await fetch(url.href, { signal: controller.signal });
      if (!response.ok) throw new Error('Collection unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const cards = Array.from(doc.querySelectorAll('.nh-collection-grid > .nh-product-card'));
      if (!cards.length) throw new Error('Missing collection products');
      const next = doc.querySelector('[data-nh-load-more]');
      const nextUrl = next ? new URL(next.getAttribute('href'), response.url || url.href) : null;
      if (nextUrl && (nextUrl.origin !== location.origin || nextUrl.pathname !== url.pathname || nextUrl.href === url.href || loadedPages.has(nextUrl.href))) {
        throw new Error('Invalid next page');
      }
      const fragment = document.createDocumentFragment();
      const added = [];
      for (const card of cards) {
        const key = productKey(card);
        if (!key || products.has(key)) continue;
        const copy = document.importNode(card, true);
        fragment.append(copy);
        added.push(copy);
        products.add(key);
      }
      grid.append(fragment);
      loadedPages.add(url.href);
      status.textContent = `${added.length} produits suppl\u00e9mentaires affich\u00e9s.`;
      if (manual && document.activeElement === button && added.length) {
        added[0].querySelector('a')?.focus({ preventScroll: true });
      }
      if (nextUrl) {
        button.href = nextUrl.href;
        button.textContent = next.textContent.trim();
        automatic = true;
      } else {
        finished = true;
        observer?.disconnect();
        container.remove();
        status.textContent += ' Tous les produits sont affich\u00e9s.';
      }
    } catch (error) {
      automatic = false;
      button.textContent = 'R\u00e9essayer de charger les produits';
      status.textContent = 'Chargement interrompu. Vous pouvez r\u00e9essayer.';
    } finally {
      clearTimeout(timeout);
      loading = false;
      button.removeAttribute('aria-busy');
      button.removeAttribute('aria-disabled');
      grid.removeAttribute('aria-busy');
      if (!finished && automatic) observer?.observe(container);
    }
  }

  button.addEventListener('click', (event) => {
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    loadMore(true);
  });

  if ('IntersectionObserver' in window && container) {
    observer = new IntersectionObserver((entries) => {
      if (entries.some((entry) => entry.isIntersecting)) loadMore();
    }, { rootMargin: '0px 0px 600px 0px' });
    observer.observe(container);
  }
})();
